import {
  DatePickerInput as MantineDatePickerInput,
  DatePickerInputProps,
} from '@mantine/dates';

export type IDatePickerInputProps = DatePickerInputProps;

/** @registry Design-layer pass-through over Mantine DatePickerInput; import this instead of @mantine/dates DatePickerInput outside src/design. Extend here when DatePickerInput needs house behavior. */
export const DatePickerInput = MantineDatePickerInput;
